
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sandbox1",
      function () {
        return require("private-next-pages/sandbox1.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sandbox1"])
      });
    }
  